import { createFileRoute, redirect } from '@tanstack/react-router';

// keep for compatibility
export const Route = createFileRoute('/account/open')({
  loader: () => {
    throw redirect({ to: '/account/accounts/create' });
  },
});
